import DigitoverBBVA from "./DigitoverBBVA";
import DigitoverBanorte from "./DigitoverBanorte";

const GenerarReferencia = ({ matricula, servicio, monto }) => {
  console.log("matricula", matricula);
  console.log("matricula 8", matricula[7]);
  console.log("matricula 9", matricula[8]);
  let referencia = "";
  referencia = matricula[7].concat(matricula[8]); //2 digitos plantel
  referencia = referencia.concat(servicio); //2 servicio
  referencia = referencia.concat(matricula.slice(0, 7)); //13 digitos matricula, se quita el digito 8
  referencia = referencia.concat(matricula.slice(8, matricula.length));
  const BBVA = DigitoverBBVA({ referencia, monto });
  const Banorte = DigitoverBanorte({ referencia, monto });

  return { BBVA, Banorte };
};

//8 y 9 numero de plantel

export default GenerarReferencia;
